import { render, staticRenderFns } from "./pricetotal.vue?vue&type=template&id=4d62dbe5&"
import script from "./pricetotal.vue?vue&type=script&lang=js&"
export * from "./pricetotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d62dbe5')) {
      api.createRecord('4d62dbe5', component.options)
    } else {
      api.reload('4d62dbe5', component.options)
    }
    module.hot.accept("./pricetotal.vue?vue&type=template&id=4d62dbe5&", function () {
      api.rerender('4d62dbe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NzjIhL0ZGxcb/JS/comp/pricetotal.vue"
export default component.exports